const CTA_URL = 'https://luc-saudemont.systeme.io/methode-bourse?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGndKzDJz8CWf8bWLrOB_QQgQl1oJvQD4kziZy3p-jvJhTY02taCKYTVwaewiM_aem_4LGEoEIw_bf1TzxevJOpIw';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface HeroSectionProps {
  formAction: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const HeroSection = ({ formAction }: HeroSectionProps) => {

  return (
    <section className="relative bg-[#1E0750] overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_50%_0%,#3B1A8C_0%,#1E0750_70%)] pointer-events-none" />

      {/* Nav */}
      <nav className="relative z-20 flex items-center px-8 lg:px-16 py-5 max-w-[1272px] mx-auto w-full">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 bg-[#A3E635] rounded-lg flex items-center justify-center">
            <span className="text-[#1E0750] font-black text-sm">LS</span>
          </div>
          <span className="text-white font-black text-xl tracking-tight">LS <span className="text-[#A3E635]">INVEST</span></span>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 max-w-[1272px] mx-auto px-8 lg:px-16 pt-6 pb-0 flex flex-col lg:flex-row items-center gap-10">
        {/* Left */}
        <div className="flex-1 max-w-[580px] pb-16">
          <div className="inline-flex items-center gap-2 bg-[#A3E635]/15 border border-[#A3E635]/40 text-[#A3E635] text-xs font-bold px-3 py-1.5 rounded-full mb-5 tracking-widest uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-[#A3E635]" />
            Accès 100% Gratuit
          </div>

          <h1 className="text-white font-black text-3xl lg:text-4xl xl:text-5xl leading-tight mb-5">
            La Méthode pour Investir<br />
            en Bourse et construire<br />
            <span className="text-[#A3E635]">ton indépendance</span>
          </h1>

          <p className="text-white/65 text-base mb-8 leading-relaxed">
            Apprends à <strong className="text-white">investir en Bourse</strong> et à générer des revenus passifs réguliers pour toi&nbsp; même si tu pars de zéro.
          </p>

          <div className="flex flex-col gap-3 max-w-[460px]">
            <a
              href={CTA_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="relative overflow-hidden bg-[#F0C932] hover:bg-[#f5d445] text-[#1E0750] font-extrabold text-sm tracking-widest uppercase py-4 px-6 rounded-lg cursor-pointer transition-all whitespace-nowrap text-center block"
            >
              <span className="relative z-10">Je veux accéder à la méthode LS INVEST →</span>
              <span className="hero-btn-shimmer" />
            </a>
            <p className="text-white/35 text-xs text-center mt-1">
              🔒 Accès immédiat · Aucune carte requise · 100% gratuit
            </p>
          </div>
        </div>

        {/* Right - Mockup */}
        <div className="hidden lg:flex flex-shrink-0 w-[500px] xl:w-[560px] self-end relative">
          <div className="w-full h-[420px] rounded-2xl overflow-hidden border border-white/10">
            <img
              src="https://public.readdy.ai/ai/img_res/ad728cedcc4a134c03d612cd18b50af1.jpg"
              alt="Méthode LS INVEST"
              className="w-full h-full object-cover object-top"
            />
          </div>
          {/* Floating badge */}
          <div className="absolute -left-6 top-10 bg-[#A3E635] text-[#1E0750] rounded-xl px-4 py-2.5 shadow-lg">
            <div className="font-black text-xl leading-none">+50</div>
            <div className="text-[10px] font-bold uppercase tracking-wide">Membres actifs</div>
          </div>
          <div className="absolute -left-6 bottom-16 bg-white text-[#1E0750] rounded-xl px-4 py-2.5 shadow-lg">
            <div className="font-black text-xl leading-none text-[#A3E635]">+4,9★</div>
            <div className="text-[10px] font-bold uppercase tracking-wide text-[#1E0750]">Note moyenne</div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="relative z-10 border-t border-white/10 mt-0">
        <div className="max-w-[1272px] mx-auto px-8 lg:px-16 py-4 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-12">
          {[
            { icon: 'ri-play-circle-line', text: '20 Modules Vidéos' },
            { icon: 'ri-group-line', text: 'Communauté privée' },
            { icon: 'ri-line-chart-line', text: 'Portefeuille en temps réel' },
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-2 text-white/80 text-sm">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-[#A3E635] text-base`} />
              </div>
              {item.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
